import { Box } from '@mui/material'

import { BudgetPreviewsStatus } from '@components/shared/BudgetPreviewsStatus'
import { emotionTheme } from '@styles/theme'
import { formattedIsoToPtBrDateTime } from '@utils/dates/formattedIsoToPtBrDateTime'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { PreviewItemProps } from '../context/types'

interface ParseBudgetPreviewsOtherExpensesProps {
  data: PreviewItemProps[]
}

export const parseBudgetPreviewsGrid = ({ data }: ParseBudgetPreviewsOtherExpensesProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'previews',
      columnName: 'Prévia',
      align: 'center',
      minWidth: '7rem',
      value: item.previewNumber ? `${item.previewNumber}ª semana` : '-'
    },
    {
      id: 'consumptionTotal',
      columnName: 'Total Outras Despesas (R$)',
      align: 'center',
      currency: true,
      value: item.previewAmount || 0
    },
    {
      id: 'previewPercentage',
      columnName: 'Prévia (%)',
      align: 'center',
      value: item.previewPercentage ? `${item.previewPercentage.toFixed(2)}%`.replace('.', ',') : '0,00%'
    },
    {
      id: 'detourPercentage',
      columnName: 'Desvio (%)',
      align: 'center',
      minWidth: '7rem',
      maxWidth: '7rem',
      value: (
        <>
          {item.deviationPercentage ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                color:
                  item.deviationPercentage <= 0 ? emotionTheme.colors.error.color : emotionTheme.colors.success.color
              }}
            >
              {item.deviationPercentage <= 0 ? <TrendingDown size="small" /> : <TrendingUp size="small" />}
              {item.deviationPercentage ? `${item.deviationPercentage.toFixed(2)}%`.replace('.', ',') : '-'}
            </Box>
          ) : (
            '-'
          )}
        </>
      )
    },
    {
      id: 'lastUpdate',
      columnName: 'Última atualização',
      align: 'center',
      minWidth: '10rem',
      maxWidth: '14.5rem',
      value: item.updatedAt ? formattedIsoToPtBrDateTime(item.updatedAt) : '-'
    },
    {
      id: 'status',
      columnName: 'Status da Prévia',
      align: 'center',
      minWidth: '10rem',
      maxWidth: '14.5rem',
      withoutTooltip: true,
      value: <BudgetPreviewsStatus status={item.previewStatus} />
    }
  ])

  return parsedData
}
